/**
 * Mapping entre les noms d'affichage/icônes et les vrais noms Terraform
 * Format: { nom_affichage: nom_terraform_reel }
 */

// Mapping AWS
export const AWS_NAME_MAPPING: Record<string, string> = {
  // Compute
  'amazon_ec2': 'aws_instance',
  'amazon_ec2_auto_scaling': 'aws_autoscaling_group',
  'amazon_elastic_kubernetes_service': 'aws_eks_cluster',
  'amazon_eks': 'aws_eks_cluster',
  'amazon_elastic_container_service': 'aws_ecs_cluster',
  'amazon_ecs': 'aws_ecs_cluster',
  'aws_lambda': 'aws_lambda_function',
  'amazon_lightsail': 'aws_lightsail_instance',

  // Storage
  'amazon_s3': 'aws_s3_bucket',
  'amazon_simple_storage_service': 'aws_s3_bucket',
  'amazon_elastic_block_store': 'aws_ebs_volume',
  'amazon_ebs': 'aws_ebs_volume',
  'amazon_elastic_file_system': 'aws_efs_file_system',
  'amazon_efs': 'aws_efs_file_system',
  'amazon_fsx': 'aws_fsx_windows_file_system',
  'amazon_glacier': 'aws_glacier_vault',

  // Database
  'amazon_rds': 'aws_db_instance',
  'amazon_dynamodb': 'aws_dynamodb_table',
  'amazon_aurora': 'aws_rds_cluster',
  'amazon_elasticache': 'aws_elasticache_cluster',
  'amazon_documentdb': 'aws_docdb_cluster',
  'amazon_neptune': 'aws_neptune_cluster',
  'amazon_timestream': 'aws_timestreamwrite_database',
  'amazon_keyspaces': 'aws_keyspaces_keyspace',

  // Network
  'amazon_vpc': 'aws_vpc',
  'amazon_virtual_private_cloud': 'aws_vpc',
  'amazon_cloudfront': 'aws_cloudfront_distribution',
  'amazon_route_53': 'aws_route53_zone',
  'amazon_route53': 'aws_route53_zone',
  'amazon_api_gateway': 'aws_api_gateway_rest_api',
  'amazon_elb': 'aws_lb',
  'elastic_load_balancing': 'aws_lb',
  'amazon_direct_connect': 'aws_dx_connection',
  'aws_app_mesh': 'aws_appmesh_mesh',

  // Security
  'aws_iam': 'aws_iam_role',
  'amazon_cognito': 'aws_cognito_user_pool',
  'amazon_guardduty': 'aws_guardduty_detector',
  'amazon_inspector': 'aws_inspector_assessment_target',
  'amazon_macie': 'aws_macie2_account',
  'aws_secrets_manager': 'aws_secretsmanager_secret',
  'aws_key_management_service': 'aws_kms_key',
  'aws_kms': 'aws_kms_key',
  'aws_certificate_manager': 'aws_acm_certificate',
  'aws_waf': 'aws_wafv2_web_acl',
  'aws_shield': 'aws_shield_protection',

  // Analytics
  'amazon_athena': 'aws_athena_database',
  'amazon_emr': 'aws_emr_cluster',
  'amazon_kinesis': 'aws_kinesis_stream',
  'amazon_kinesis_data_streams': 'aws_kinesis_stream',
  'amazon_kinesis_data_firehose': 'aws_kinesis_firehose_delivery_stream',
  'amazon_redshift': 'aws_redshift_cluster',
  'amazon_quicksight': 'aws_quicksight_data_set',
  'aws_glue': 'aws_glue_catalog_database',
  'amazon_managed_streaming_for_apache_kafka': 'aws_msk_cluster',
  'amazon_msk': 'aws_msk_cluster',

  // Machine Learning
  'amazon_sagemaker': 'aws_sagemaker_notebook_instance',
  'amazon_comprehend': 'aws_comprehend_document_classifier',
  'amazon_rekognition': 'aws_rekognition_collection',
  'amazon_textract': 'aws_textract_project',
  'amazon_translate': 'aws_translate_text',
  'amazon_polly': 'aws_polly_lexicon',
  'amazon_lex': 'aws_lex_bot',

  // Application Integration
  'amazon_sns': 'aws_sns_topic',
  'amazon_sqs': 'aws_sqs_queue',
  'amazon_eventbridge': 'aws_cloudwatch_event_rule',
  'aws_step_functions': 'aws_sfn_state_machine',
  'amazon_mq': 'aws_mq_broker',

  // Developer Tools
  'aws_codecommit': 'aws_codecommit_repository',
  'aws_codebuild': 'aws_codebuild_project',
  'aws_codedeploy': 'aws_codedeploy_app',
  'aws_codepipeline': 'aws_codepipeline',
  'aws_cloud9': 'aws_cloud9_environment_ec2',
  'aws_x_ray': 'aws_xray_sampling_rule',

  // Management
  'amazon_cloudwatch': 'aws_cloudwatch_metric_alarm',
  'aws_cloudtrail': 'aws_cloudtrail',
  'aws_config': 'aws_config_configuration_recorder',
  'aws_systems_manager': 'aws_ssm_parameter',
  'aws_cloudformation': 'aws_cloudformation_stack',
  'aws_organizations': 'aws_organizations_organization',
  'aws_control_tower': 'aws_controltower_landing_zone',

  // Containers
  'amazon_elastic_container_registry': 'aws_ecr_repository',
  'amazon_ecr': 'aws_ecr_repository',
  'aws_fargate': 'aws_ecs_service',

  // IoT
  'aws_iot_core': 'aws_iot_thing',
  'aws_iot_greengrass': 'aws_greengrass_group',

  // Media
  'amazon_elastic_transcoder': 'aws_elastictranscoder_pipeline',
  'aws_elemental_mediaconvert': 'aws_media_convert_queue',
  'aws_elemental_medialive': 'aws_medialive_channel',

  // Business Applications
  'amazon_simple_email_service': 'aws_ses_domain_identity',
  'amazon_ses': 'aws_ses_domain_identity',
  'amazon_workspaces': 'aws_workspaces_workspace',
  'amazon_appstream': 'aws_appstream_fleet',
  'amazon_chime': 'aws_chime_voice_connector',

  // End User Computing
  'amazon_workdocs': 'aws_workdocs_user',

  // Blockchain
  'amazon_managed_blockchain': 'aws_managedblockchain_network',

  // Game Tech
  'amazon_gamelift': 'aws_gamelift_fleet',
};

// Mapping GCP
export const GCP_NAME_MAPPING: Record<string, string> = {
  // Compute (avec et sans préfixe google_)
  'compute_engine': 'google_compute_instance',
  'google_compute_engine': 'google_compute_instance',
  'google_gce': 'google_compute_instance',
  'game_servers': 'google_game_services_game_server_cluster',
  'vmware_engine': 'google_vmware_engine_private_cloud',

  // Kubernetes
  'google_kubernetes_engine': 'google_container_cluster',
  'google_gke': 'google_container_cluster',
  'gke_on-prem': 'google_container_cluster',

  // App Engine & Cloud Run
  'app_engine': 'google_app_engine_application',
  'google_app_engine': 'google_app_engine_application',
  'cloud_run': 'google_cloud_run_service',
  'google_cloud_run': 'google_cloud_run_service',
  'cloud_run_for_anthos': 'google_cloud_run_service',

  // Functions
  'cloud_functions': 'google_cloudfunctions_function',
  'google_cloud_functions': 'google_cloudfunctions_function',

  // Storage
  'cloud_storage': 'google_storage_bucket',
  'google_cloud_storage': 'google_storage_bucket',
  'google_gcs': 'google_storage_bucket',
  'persistent_disk': 'google_compute_disk',
  'google_persistent_disk': 'google_compute_disk',
  'local_ssd': 'google_compute_disk',
  'filestore': 'google_filestore_instance',
  'google_filestore': 'google_filestore_instance',

  // Database
  'cloud_sql': 'google_sql_database_instance',
  'google_cloud_sql': 'google_sql_database_instance',
  'cloud_spanner': 'google_spanner_instance',
  'google_cloud_spanner': 'google_spanner_instance',
  'bigtable': 'google_bigtable_instance',
  'google_cloud_bigtable': 'google_bigtable_instance',
  'firestore': 'google_firestore_database',
  'google_firestore': 'google_firestore_database',
  'datastore': 'google_datastore_index',
  'google_cloud_datastore': 'google_datastore_index',
  'memorystore': 'google_redis_instance',
  'google_cloud_memorystore': 'google_redis_instance',

  // Network
  'virtual_private_cloud': 'google_compute_network',
  'google_virtual_private_cloud': 'google_compute_network',
  'cloud_network': 'google_compute_network',
  'cloud_vpn': 'google_compute_vpn_gateway',
  'google_cloud_vpn': 'google_compute_vpn_gateway',
  'cloud_load_balancing': 'google_compute_forwarding_rule',
  'google_cloud_load_balancing': 'google_compute_forwarding_rule',
  'cloud_cdn': 'google_compute_backend_bucket',
  'google_cloud_cdn': 'google_compute_backend_bucket',
  'cloud_interconnect': 'google_compute_interconnect_attachment',
  'google_cloud_interconnect': 'google_compute_interconnect_attachment',
  'cloud_armor': 'google_compute_security_policy',
  'google_cloud_armor': 'google_compute_security_policy',
  'cloud_nat': 'google_compute_router_nat',
  'cloud_router': 'google_compute_router',
  'cloud_dns': 'google_dns_managed_zone',
  'cloud_domains': 'google_dns_managed_zone',

  // Security & IAM
  'identity_and_access_management': 'google_service_account',
  'google_cloud_iam': 'google_service_account',
  'secret_manager': 'google_secret_manager_secret',
  'google_secret_manager': 'google_secret_manager_secret',
  'key_management_service': 'google_kms_key_ring',
  'google_cloud_kms': 'google_kms_key_ring',
  'cloud_hsm': 'google_kms_crypto_key',
  'identity_platform': 'google_identity_platform_config',
  'google_identity_platform': 'google_identity_platform_config',
  'identity-aware_proxy': 'google_iap_brand',
  'security_command_center': 'google_scc_source',
  'google_security_command_center': 'google_scc_source',
  'binary_authorization': 'google_binary_authorization_policy',
  'certificate_authority_service': 'google_privateca_certificate_authority',
  'certificate_manager': 'google_certificate_manager_certificate',

  // Big Data & Analytics
  'bigquery': 'google_bigquery_dataset',
  'google_bigquery': 'google_bigquery_dataset',
  'dataflow': 'google_dataflow_job',
  'google_cloud_dataflow': 'google_dataflow_job',
  'dataproc': 'google_dataproc_cluster',
  'google_cloud_dataproc': 'google_dataproc_cluster',
  'dataproc_metastore': 'google_dataproc_metastore_service',
  'pubsub': 'google_pubsub_topic',
  'google_cloud_pub_sub': 'google_pubsub_topic',
  'cloud_composer': 'google_composer_environment',
  'google_cloud_composer': 'google_composer_environment',
  'dataprep': 'google_data_fusion_instance',
  'cloud_data_fusion': 'google_data_fusion_instance',
  'dataplex': 'google_dataplex_lake',
  'datastream': 'google_datastream_stream',
  'data_catalog': 'google_data_catalog_entry',

  // AI/ML
  'vertexai': 'google_vertex_ai_dataset',
  'google_vertex_ai': 'google_vertex_ai_dataset',
  'ai_platform': 'google_vertex_ai_endpoint',
  'google_ai_platform': 'google_vertex_ai_endpoint',
  'ai_platform_unified': 'google_vertex_ai_endpoint',
  'automl': 'google_vertex_ai_dataset',
  'automl_vision': 'google_vertex_ai_dataset',
  'automl_natural_language': 'google_vertex_ai_dataset',
  'automl_tables': 'google_vertex_ai_dataset',
  'automl_translation': 'google_vertex_ai_dataset',
  'automl_video_intelligence': 'google_vertex_ai_dataset',
  'cloud_vision_api': 'google_vertex_ai_endpoint',
  'google_cloud_vision': 'google_vertex_ai_endpoint',
  'cloud_natural_language_api': 'google_vertex_ai_endpoint',
  'google_cloud_natural_language': 'google_vertex_ai_endpoint',
  'cloud_translation_api': 'google_translate_glossary',
  'google_cloud_translation': 'google_translate_glossary',
  'speech-to-text': 'google_speech_to_text_recognizer',
  'text-to-speech': 'google_text_to_speech_voice',
  'document_ai': 'google_document_ai_processor',
  'dialogflow': 'google_dialogflow_agent',
  'dialogflow_cx': 'google_dialogflow_cx_agent',
  'recommendations_ai': 'google_retail_product',
  'retail_api': 'google_retail_product',

  // Developer Tools
  'cloud_build': 'google_cloudbuild_trigger',
  'google_cloud_build': 'google_cloudbuild_trigger',
  'artifact_registry': 'google_artifact_registry_repository',
  'google_artifact_registry': 'google_artifact_registry_repository',
  'container_registry': 'google_container_registry',
  'google_container_registry': 'google_container_registry',
  'cloud_deploy': 'google_clouddeploy_delivery_pipeline',
  'cloud_code': 'google_cloudbuild_trigger',

  // Management & Monitoring
  'cloud_monitoring': 'google_monitoring_alert_policy',
  'google_cloud_monitoring': 'google_monitoring_alert_policy',
  'cloud_logging': 'google_logging_project_sink',
  'google_cloud_logging': 'google_logging_project_sink',
  'cloud_deployment_manager': 'google_deployment_manager_deployment',
  'google_cloud_deployment_manager': 'google_deployment_manager_deployment',
  'trace': 'google_cloud_trace',
  'debugger': 'google_debugger',
  'profiler': 'google_profiler_profile',
  'error_reporting': 'google_error_reporting_error_group',

  // API Management
  'cloud_endpoints': 'google_endpoints_service',
  'google_cloud_endpoints': 'google_endpoints_service',
  'apigee_api_platform': 'google_apigee_organization',
  'google_apigee': 'google_apigee_organization',
  'api_gateway': 'google_api_gateway_api',
  'cloud_api_gateway': 'google_api_gateway_api',

  // Others
  'cloud_scheduler': 'google_cloud_scheduler_job',
  'cloud_tasks': 'google_cloud_tasks_queue',
  'workflows': 'google_workflows_workflow',
  'eventarc': 'google_eventarc_trigger',
  'iot_core': 'google_iot_registry',
  'anthos': 'google_container_cluster',
  'anthos_service_mesh': 'google_service_mesh_mesh',
  'bare_metal_solutions': 'google_bare_metal_solution_instance',
};

/**
 * Obtenir le vrai nom Terraform à partir d'un nom d'affichage
 */
export function getTerraformResourceName(displayName: string): string {
  // D'abord, chercher dans les mappings (pour les noms comme "aws_lambda" -> "aws_lambda_function")
  const mapped = AWS_NAME_MAPPING[displayName] || GCP_NAME_MAPPING[displayName];
  if (mapped) {
    return mapped;
  }

  // Si pas de mapping trouvé et que ça ressemble déjà à un nom Terraform, le retourner tel quel
  if (displayName.startsWith('azurerm_') || displayName.startsWith('aws_') || displayName.startsWith('google_')) {
    return displayName;
  }

  // Sinon, retourner le nom tel quel (fallback)
  return displayName;
}

/**
 * Détecter le provider à partir d'un nom d'affichage
 */
export function detectProviderFromDisplayName(displayName: string): 'azure' | 'aws' | 'gcp' | null {
  if (displayName.startsWith('azurerm_')) return 'azure';
  if (displayName.startsWith('aws_')) return 'aws';
  if (displayName.startsWith('google_')) return 'gcp';

  // Chercher dans les mappings
  if (AWS_NAME_MAPPING[displayName]) return 'aws';
  if (GCP_NAME_MAPPING[displayName]) return 'gcp';

  // Heuristique basée sur les préfixes courants
  if (displayName.startsWith('amazon_') || displayName.startsWith('aws_')) return 'aws';
  if (displayName.startsWith('google_') || displayName.startsWith('gcp_')) return 'gcp';
  if (displayName.startsWith('azure_') || displayName.startsWith('microsoft_')) return 'azure';

  return null;
}
